import "./DesktopContact.css";
import { useState } from "react";

export default function DesktopContact() {
  const [values, setValues] = useState({
    email: "",
    username: "",
    message: "",
  });
  const [submitted, setSubmitted] = useState(false);

  function handleChange(e) {
    const { name, value } = e.target;
    setValues((prev) => ({ ...prev, [name]: value }));
  }

  function handleSubmit(e) {
    e.preventDefault();
    setSubmitted(true);
  }

  return (
    <div className="desktop-contact">
      <div className="desktop-contact__card">
        <h1>Contact Us</h1>
        <p>Let us know what's on your mind.</p>

        <form className="desktop-contact__form" onSubmit={handleSubmit}>
          <label className="desktop-contact__field">
            <span>Email</span>
            <input
              type="email"
              name="email"
              placeholder="you@email.com"
              value={values.email}
              onChange={handleChange}
              required
            />
          </label>

          <label className="desktop-contact__field">
            <span>Username</span>
            <input
              type="text"
              name="username"
              placeholder="Your name"
              value={values.username}
              onChange={handleChange}
              required
            />
          </label>

          <label className="desktop-contact__field">
            <span>Message</span>
            <textarea
              name="message"
              placeholder="Type your message"
              rows={6}
              value={values.message}
              onChange={handleChange}
              required
            />
          </label>

          <button type="submit" className="desktop-contact__submit">
            Submit
          </button>

          {submitted && (
            <p className="desktop-contact__success">Thanks! We'll get back to you soon.</p>
          )}
        </form>
      </div>
    </div>
  );
}
